<template>
  <div class="doc-form">
    <div class="form">
      <material-input
        v-model="doc.url"
        type="text"
        label="Document URL"
        :required="true"
        name="DocumentURL"
      />

      <div class="half-row">
        <material-input
          v-model="doc.title"
          type="text"
          label="File name"
          :required="true"
          name="DocumentFileName"
        />

        <dropdown
          :options="file_options"
          :value="doc.type"
          :onChange="val => closeDocType(val)"
          placeholder="File type"
          :required="true"
        />
      </div>

      <!-- <material-input
        v-model="doc.description"
        type="textarea"
        label="Description"
        :required="true"
        name="DocumentDesc"
      /> -->
    </div>

    <div class="action-btns">
      <i @click="save(doc)" class="material-icons close-btn" :disabled="!valid"
        >check</i
      >
      <i @click="onClose()" class="material-icons close-btn" v-if="onClose"
        >clear</i
      >
    </div>
  </div>
</template>

<script>
import MaterialInput from './MaterialInput';
import Dropdown from './Dropdown';

export default {
  name: 'DocumentForm',
  props: {
    document: Object,
    onSave: Function,
    onClose: Function,
    refreshTrigger: Number,
  },
  components: {
    'material-input': MaterialInput,
    dropdown: Dropdown,
  },
  methods: {
    clone(doc) {
      const clone = JSON.stringify(doc);
      return JSON.parse(clone);
    },
    closeDocType(val) {
      this.doc.type = val;
      setTimeout(() => this.save(this.doc), 100);
    },
    save(doc) {
      if (this.valid) {
        this.onSave(doc);
      }
    },
  },
  computed: {
    valid() {
      return this.doc.title && this.doc.url;
    },
  },
  data() {
    return {
      doc: this.clone(this.document),
      file_options: [
        { text: 'PDF', value: 'PDF' },
        { text: 'Word', value: 'Word' },
        { text: 'Excel', value: 'Excel' },
        { text: 'PowerPoint', value: 'PowerPoint' },
        { text: 'Image', value: 'Image' },
        { text: 'Zip', value: 'Zip' },
        { text: 'Other', value: 'Other' },
      ],
    };
  },
  watch: {
    refreshTrigger() {
      this.doc = this.clone(this.document);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.doc-form {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  position: relative;

  .form {
    flex: 1;

    .material-input:last-child {
      margin-bottom: -24px;
    }

    .material-input {
      margin-bottom: -10px;
    }

    > .half-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: nowrap;
      margin-bottom: 15px;

      > * {
        width: calc(50% - 10px);

        ::v-deep input {
          margin-bottom: 10px !important;
        }
      }
    }
  }

  a {
    display: inline-block;
    width: 100px;
    min-width: 100px;
    height: 30px;
    padding: 4px 20px 5px;
    margin: 0 0 0 25px;
  }
}

.action-btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: 10px;
  width: 70px;
  margin-right: -10px;
}

.close-btn {
  padding: 5px;
  color: #acb6c1;
  cursor: pointer;
  font-size: 24px;

  &:hover {
    color: $sidebar-color;
  }

  &[disabled] {
    cursor: not-allowed;
    color: #acb6c1;
  }
}
</style>
